import { createFileRoute } from "@tanstack/react-router";
import {
  Box,
  Empty,
  EmptyDescription,
  EmptyHeader,
  EmptyTitle,
  ScrollArea,
  Spinner,
} from "@salestrak/ui";
import { PageHeader, PageHeaderSubtitle, PageHeaderTitle } from "#app/components/page-header";
import { useUserSettings } from "#app/lib/hooks/use-user-settings";
import { ProfileForm } from "#app/components/settings/profile-form";
import { SecuritySettings } from "#app/components/settings/security-settings";

function ProfilePage() {
  const { user, isLoading, error, updateUserField } = useUserSettings();

  if (isLoading && !user) {
    return (
      <Box fill="flex" align="center" justify="center">
        <Spinner />
      </Box>
    );
  }

  if (!user) {
    return (
      <Box fill="flex" align="center" justify="center">
        <Empty>
          <EmptyHeader>
            <EmptyTitle>Unable to load user settings</EmptyTitle>
            {error ? (
              <EmptyDescription>{error.message}</EmptyDescription>
            ) : null}
          </EmptyHeader>
        </Empty>
      </Box>
    );
  }

  return (
    <Box direction="column" fill="flex">
      <ScrollArea>
        <PageHeader centered>
          <PageHeaderTitle>{user.name}</PageHeaderTitle>
          <PageHeaderSubtitle>Manage your personal profile and account settings.</PageHeaderSubtitle>
        </PageHeader>
        <Box align="center" paddingY="md" paddingX="md">
          <Box gap="xl" fill="width" maxWidth={800}>
            <ProfileForm
              user={user}
              onFieldSave={updateUserField}
              dangerZone={[
                {
                  id: "leave-workspace",
                  label: "Remove yourself from the workspace",
                  buttonLabel: "Leave workspace...",
                  variant: "destructive",
                },
              ]}
            >
              <SecuritySettings />
            </ProfileForm>
          </Box>
        </Box>
      </ScrollArea>
    </Box>
  );
}

export const Route = createFileRoute("/(app)/$workspace/settings/profile")({
  component: ProfilePage,
});
